<template>
  <li class="wf-text-gray-400 wf-lowercase wf-text-sm wf-font-light">
    <button
      @click.prevent="updateOpenList"
      :class="menuClasses"
    >
      <span class="lowercase" v-text="title"></span>
      <i :class="`fas ${ open == trigger ? 'fa-caret-up':'fa-caret-down'}`"></i>
    </button>
    <div
      v-show="open == trigger"
      :class="open == trigger ? 'wf-bg-gray-100 wf-text-gray-500 wf-shadow-inner' : ''"
    >
      <ul class="wf-p-2 wf-max-h-64 wf-overflow-scroll">
        <slot name="list"></slot>
      </ul>
    </div>
  </li>
</template>

<script>
  export default {
    props: {
      trigger: {
        type: String,
        required: true,
      },
      title: {
        type: String,
        required: true,
      },
      open: {
        type: String,
        required: true
      },
    },
    computed: {
      menuClasses() {
        let classes = [
          'wf-p-2', 'wf-flex', 'wf-justify-between',
          'wf-w-full', 'wf-items-center', 'wf-hover:text-blue-500', 'focus:wf-outline-none',
        ]
        if (this.open == this.trigger) {
          classes.push('wf-text-blue-500')
        }
        return classes
      },
    },
    methods: {
      updateOpenList() {
        this.$emit('updateOpen', this.trigger)
      }    
    }  
  }
</script>